import React from "react";

export const OPERATOR_ALERTS_HELP_TITLE = "Alertas ao app";

export function OperatorAlertsHelpContent() {
  return (
    <>
      <p>
        Envie um aviso para o tablet do operador. A mensagem abre em destaque
        na tela do app até ele tocar em <strong>OK, confirmo que li</strong>.
      </p>
      <ul>
        <li>
          Informe o <strong>título</strong> e o <strong>texto</strong> do alerta.
        </li>
        <li>
          Em <strong>Enviar para</strong>, escolha um ou mais operadores,
          ou marque todos da fazenda.
        </li>
        <li>
          A mensagem só abre no tablet quando a telemetria daquele operador
          está ativa. Se estiver desligada, o alerta espera e aparece assim
          que ele ligar a telemetria.
        </li>
        <li>
          O histórico guarda cada envio e mostra quem confirmou a leitura
          e quem ainda não leu.
        </li>
      </ul>
    </>
  );
}
